import { useState } from "react";
import { OnlineClubTrans, ToasterTrans } from "../../utils/translations";

function resolveClubCardHref(link) {
  if (!link) return null;
  if (link === "schedule") return "/schedule";
  return link;
}

/**
 * Flip cards grid matching the Online Club landing “what’s included” section.
 */
export default function OnlineClubFlipCardsGrid({ items, language, isMobile, setToaster }) {
  const [flippedCard, setFlippedCard] = useState(null);
  const t = OnlineClubTrans[language];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6 text-center items-stretch">
      {items.map((item, idx) => {
        const isFeatured = item.featured === true;
        const href = resolveClubCardHref(item.link);
        return (
          <div
            key={idx}
            className={`relative group w-full h-80 max-w-sm mx-auto md:max-w-none [perspective:1000px] ${isFeatured ? "z-10 md:scale-[1.06] md:-my-1" : ""}`}
            onClick={(e) => {
              if (isMobile && e.target.tagName !== "BUTTON" && e.target.tagName !== "A") {
                setFlippedCard(flippedCard === idx ? null : idx);
              }
            }}
            onMouseEnter={() => {
              if (!isMobile) setFlippedCard(idx);
            }}
            onMouseLeave={() => {
              if (!isMobile) setFlippedCard(null);
            }}
            style={{ cursor: isMobile ? "pointer" : "default" }}
          >
            {isFeatured ? (
              <span className="pointer-events-none absolute -top-3 left-1/2 z-30 -translate-x-1/2 whitespace-nowrap rounded-full bg-clay px-3 py-1 font-sans text-[10px] font-medium uppercase tracking-[0.14em] text-white shadow-md">
                {t.constructorFeaturedBadge}
              </span>
            ) : null}
            <div
              className={`relative h-full w-full rounded-sm transition-transform duration-700 [transform-style:preserve-3d] ${isFeatured ? "shadow-xl shadow-clay/30 ring-2 ring-clay ring-offset-2 ring-offset-cream" : ""} ${flippedCard === idx ? "[transform:rotateY(180deg)]" : ""} ${!isMobile ? "group-hover:[transform:rotateY(180deg)]" : ""}`}
            >
              <div
                className={`absolute inset-0 bg-warm-white rounded-sm flex flex-col items-center justify-center p-6 [backface-visibility:hidden] ${isFeatured ? "border-2 border-clay/50" : "border border-sand-dark"}`}
              >
                <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-4" />
                <h3 className="font-serif text-xl font-medium text-ink mb-2">{item.title}</h3>
                <p className="text-sm font-sans font-light text-ink-mid mb-4 line-clamp-3">{item.description}</p>
                <div className="absolute bottom-4 right-5 text-xs text-ink-light md:hidden pointer-events-none select-none">⤷</div>
              </div>
              <div
                className={`absolute inset-0 rounded-sm border flex flex-col items-center p-6 text-white [transform:rotateY(180deg)] [backface-visibility:hidden] ${isFeatured ? "border-clay-dark bg-gradient-to-br from-clay to-clay-dark" : "border-clay-dark bg-clay"}`}
              >
                <div className="flex flex-col items-center justify-center text-center flex-1 min-h-0">
                  <h3 className="font-serif text-xl font-medium mb-4 text-white">{item.title}</h3>
                  <p className="text-sm text-white/90 font-sans font-light">{item.extra}</p>
                </div>
                {href && language === "russian" ? (
                  <a
                    href={href}
                    className="border border-white px-4 py-2 rounded-sm hover:bg-warm-white hover:text-clay transition text-xs font-sans uppercase tracking-wider flex-shrink-0"
                    onClick={(e) => e.stopPropagation()}
                    target={href.startsWith("http") ? "_blank" : undefined}
                    rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  >
                    {item.button}
                  </a>
                ) : (
                  <button
                    type="button"
                    className="border border-white px-4 py-2 rounded-sm hover:bg-warm-white hover:text-clay transition text-xs font-sans uppercase tracking-wider flex-shrink-0"
                    onClick={(e) => {
                      e.stopPropagation();
                      setToaster({
                        message: ToasterTrans[language].comingSoon,
                        type: "info",
                        show: true,
                      });
                    }}
                  >
                    {item.button}
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
